import { useEffect, useState } from 'react'
import { useTheme, AiSettingsSection } from '@foroba/ui'
import { fetchMe, apiFetch, getBiometricEnabled, setBiometricEnabled, type SessionUser } from '../../lib/pfhApi'
import { Capacitor } from '@capacitor/core'
import i18n from '../../i18n'
import { PageShell, SectionList, Row, Note, Segmented } from './SectionList'

const CURRENCIES = ['EUR', 'USD', 'GBP', 'CHF', 'JPY']
const LANGS = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
]

export function SettingsPage() {
  const { theme, setTheme } = useTheme()
  const [user, setUser] = useState<SessionUser | null>(null)
  const [bio, setBio] = useState(getBiometricEnabled())
  const isNative = Capacitor.isNativePlatform()

  useEffect(() => { void fetchMe().then(setUser) }, [])

  async function setCurrency(cur: string) {
    await apiFetch('/auth/me/profile', {
      method: 'PUT',
      body: JSON.stringify({ preferred_currency: cur }),
    })
    setUser(await fetchMe())
  }

  function toggleBio() {
    const next = !bio
    setBiometricEnabled(next)
    setBio(next)
  }

  return (
    <PageShell title="Settings">
      <SectionList title="Appearance">
        <Segmented
          label="Theme"
          value={theme}
          onChange={setTheme}
          options={[
            { value: 'light', label: 'Light' },
            { value: 'dark', label: 'Dark' },
            { value: 'system', label: 'System' },
          ]}
        />
      </SectionList>
      <Note>System follows your phone's appearance setting.</Note>

      <SectionList title="Language">
        {LANGS.map((l) => (
          <Row
            key={l.code}
            label={l.label}
            onClick={() => void i18n.changeLanguage(l.code)}
            value={i18n.language.startsWith(l.code) ? '✓' : undefined}
          />
        ))}
      </SectionList>

      <SectionList title="Currency">
        {CURRENCIES.map((c) => (
          <Row
            key={c}
            label={c}
            onClick={() => void setCurrency(c)}
            value={user?.preferred_currency === c ? '✓' : undefined}
          />
        ))}
      </SectionList>

      <AiSettingsSection apps={['pazuru', 'tsumi', 'foroba']} platform="ios" />

      {isNative && (
        <SectionList title="Security">
          <Row label="Biometric unlock" onClick={toggleBio} value={bio ? 'On' : 'Off'} />
        </SectionList>
      )}
    </PageShell>
  )
}
